import React, { useState, useEffect, useRef } from 'react';
import { Input, Modal, Form, Button, Upload, message, Spin } from 'antd';
import { PlusOutlined, UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import ImgCrop from 'antd-img-crop';
import NewMessage from '../../component/newMessage/newMessage';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { studentCheckLogin } from '../newMain/studentMain';
import ConfirmModal from './confirmModal';
import './studentDetail.css';

import saveImg from '../../public/img/newMain/Save.png';
import tag1 from '../../public/img/tag/tag1.png';

const { confirm } = Modal;

const StudentDetail = (props) => {
    const messageRef = useRef();
    const confirmRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const imageNum = 1;
    const [imageFile, setImageFile] = useState([]);
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [studentModel, setStudentModel] = useState({});
    const [documentFileList, setDocumentFileList] = useState([]);
    const [fileSize, setFileSize] = useState('');

    useEffect(() => {
        if (!Config.studentInfo?.studentId) {
            studentCheckLogin();
        }
        searchFileSize();
        searchById(Config.studentInfo?.studentId);
    }, []);

    const searchFileSize = () => {
        let model = {
            "segment": 'SYSTEM_CONFIG',
            "code": 'FILE_SIZE',
        }
        Base.callBackApi("commonDropDown/searchSysParamByCode", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                const sizeNumber = parseInt(data.object?.parmValue1 ?? '');
                const size = isNaN(sizeNumber) ? 10 : sizeNumber;
                setFileSize(size);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            accountUserId: model.studentAcctId ?? '',
            studentAcctId: model.studentAcctId ?? '',
            studentName: (model.firstName + ' ' + model.lastName) ?? "",
            email: model.email ?? Config?.studentInfo?.studentAcctId + '@stu.thei.edu.hk',
            // birthMonth: (model.birthMonth && moment(model.birthMonth, Config.dateFormat6)) ?? '',
            cohortYear: Config?.studentInfo?.cohortYear ?? '',
            studyYearEntry: Config?.studentInfo?.studyYearEntry ?? '',
            studentEntryYear: Config?.studentInfo?.studentEntryYear ?? '',
            progTitle: Config?.studentInfo?.progTitle ?? '',
            contactPhone: model.contactPhone ?? '',
            whatsApp: model.whatsApp ?? '',
            weChat: model.weChat ?? '',
            linkedIn: model.linkedIn ?? '',
            personalWeb: model.personalWeb ?? '',
        });
    }

    const update = () => {
        if (imageFile && imageFile.length > 0 && imageFile[0].imgStatus === 'NEW') {
            confirmRef.current.setIsShow(true)
        } else {
            form.submit();
        }
    }

    const confirmSave = (flag) => {
        if (flag) {
            form.submit();
        }
        confirmRef.current.setIsShow(false)
    }

    const onFinish = (model) => {
        if (isLoad) {
            return;
        }
        setIsLoad(true);
        let formData = new FormData();
        model.studentId = studentModel.studentId;
        model.lastUpdatedDate = studentModel.lastUpdatedDate;

        if (imageFile && imageFile.length > 0) {
            model.studentPhotoModel = {
                status: imageFile[0].imgStatus,
                url: imageFile[0].originUrl,
            };
        }
        // model.birthMonth = model.birthMonth && moment(model.birthMonth).format(Config.dateFormat8)

        // 修改文件，区分新上传和旧文件
        let oldFiles = [];
        for (let file of documentFileList) {
            if (file.status != undefined && file.status != 'old') {
                formData.append('files', file.originFileObj);
            } else {
                oldFiles.push(file.uid);
            }
        }
        model.pastList = oldFiles;
        model.resume = null;
        formData.append("model", JSON.stringify(model));
        Base.callBackUploadApi("studentInfo/updateStudent", formData).then((data) => {
            if ("SUCCESS" === data.msg) {
                opendialog("You've successfully updated Personal Profile.");
            } else {
                message.error(data.msg)
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const handleDocumentChange = (file) => {
        let newFileList = file.fileList;
        file = file.file;
        if (file.status === "uploading") {
            const maxSize = fileSize * 1024 * 1024; // 10MB
            // 检查文件大小
            if (file.size > maxSize) {
                message.error('File size must be less than ' + fileSize + 'MB.');
                return;
            }
            setDocumentFileList(newFileList);
            return
        } else if (file.status === "error") {
            message.error(file.error.message);
        } else if (file?.response?.error) {
            message.error(file.response.error?.message);
        }
        setDocumentFileList(newFileList.filter(item => (item.status === 'done' && !item.response.error) || item.status === 'old'));
    }


    const beforeUpload = (file) => {
        // 检查当前已上传文件数量
        if (documentFileList.length >= 4) {
            message.error('You can upload up to 4 files.');
            return false; // 阻止上传
        }
        return true; // 允许上传
    };

    const opendialog = (param) => {
        messageRef.current.setContent(param)
        messageRef.current.setIsShow(true)
    }

    const done = () => {
        messageRef.current.setIsShow(false);
        searchById(Config.studentInfo?.studentId);
    }

    const searchById = (studentId) => {
        let model = {
            "studentId": studentId,
            "cohortYear": Config.cohortYear,
        }
        Base.callBackApi("studentInfo/searchStudentById", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                let file = [];
                if (model.studentPhoto) {
                    file.push({
                        url: Config.studentPhotoImg + model.studentPhoto + '?' + Config.sasToken,
                        originUrl: model.studentPhoto,
                        thumbUrl: Config.studentPhotoPath + model.studentPhoto + '?' + Config.sasToken,
                        imgStatus: "OLD"
                    })
                }
                setImageFile(file);
                Config.studentInfo.firstName = model.firstName;
                Config.studentInfo.lastName = model.lastName;
                Config.studentInfo.email = model.email;
                Config.studentInfo.personalPortfolio = model.personalPortfolio;
                initForm(model);
                setStudentModel(model)
                setDocumentFileList(model?.studentAnnexModelList?.map(item => {
                    return {
                        uid: item.studentAnnexId,
                        name: item.annexName,
                        path: item.storagePath,
                        url: Config.studentFiles + item.storagePath,
                        status: 'old'
                    }
                }));
            } else {
                message.error(data.msg)
            }
        })
    }


    const checkImg = (value) => {
        if (!!imageFile && imageFile.length > 0 && !!value) {
            let list = value.fileList;
            if (list.find(item => item.status === "uploading")) {
                return Promise.reject("Please wait for uploading the photo.");
            }
            if (list.find(item => item.status === "error")) {
                return Promise.reject("Please handle the failed images first.");
            }
        }
        return Promise.resolve();
    }

    const handleChangeImg = (file) => {
        let fileList = file.fileList;
        file = file.file;
        if (file.status === "removed") {
            let index = imageFile.findIndex(item => item.uid == file.uid);
            let fileList = JSON.parse(JSON.stringify(imageFile));
            fileList.splice(index, 1)
        } else {
            const reader = new FileReader();
            reader.readAsDataURL(file.originFileObj);
            reader.onload = (e) => {
                var img = document.createElement("img");
                img.src = e.target.result;
                img.onload = function () {
                    if (img.width < 100 || img.height < 100 || (img.width / img.height) !== 1) {
                        fileList[fileList.length - 1].status = "irregular";
                        form.validateFields(['img']);
                    }
                }
                fileList[fileList.length - 1].originUrl = e.target.result;
                fileList[fileList.length - 1].imgStatus = "NEW";
            }
        }
        setImageFile(fileList);
    }

    /**关闭图片弹窗 */
    const handleCancel = () => {
        setPreviewVisible(false);
    }

    const handlePreview = (file) => {
        setPreviewImage(file.url || file.originUrl);
        setPreviewVisible(true);
    }

    const handleRemove = (file) => {
        confirm({
            content: "Confirm delete Photo?",
            okText: "Confirm",
            okType: 'danger',
            cancelText: "Cancel",
            onOk() {
                let index = imageFile.findIndex(item => item.uid == file.uid);
                let fileList = JSON.parse(JSON.stringify(imageFile));
                fileList.splice(index, 1);
                setImageFile(fileList);
            },
            onCancel() {
            },
        });
        return false;
    }

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div>Upload Photo</div>
        </div>
    );

    const deleteFile = (index) => {
        let newList = JSON.parse(JSON.stringify(documentFileList));
        newList.splice(index, 1);
        setDocumentFileList(newList);
    }

    const downloadFile = (item) => {
        if (!Base.stopClick()){
            return;
        }
        Base.downloadFile(item.url + '?' + Config.sasToken, item.name)
        // if (item.lastModified || isLoad) {
        //     return;
        // }
        // setIsLoad(true);
        // item.code = "STUDENT_PATH";
        // fetch(Config.apiDownloadServer + "downloadFile/downloadFile", {
        //     method: 'POST',
        //     body: JSON.stringify(item),
        //     headers: Config.header,
        //     mode: 'cors',
        //     cache: 'default'
        // }).then(res => res.blob()).then(blob => {
        //     if (blob.type == "application/json") {
        //         var reader = new FileReader();
        //         reader.onload = e => {
        //             var data = JSON.parse(e.target.result);
        //             message.error(data.msg);
        //         }
        //         reader.readAsText(blob);
        //     } else {
        //         if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
        //             window.navigator.msSaveOrOpenBlob(blob, item.name);
        //         } else {// for Non-IE (chrome, firefox etc.)
        //             var a = document.createElement('a');
        //             document.body.appendChild(a);
        //             a.style = 'display: none';
        //             var url = window.URL.createObjectURL(blob);
        //             a.href = url;
        //             a.download = item.name;
        //             a.click();
        //             a.remove();
        //             window.URL.revokeObjectURL(url);
        //         }
        //     }
        // }).catch(err => ({ err })).finally(() => {
        //     setIsLoad(false)
        // });
    }

    // const checkPhone = (value) => {
    //     if(value) {
    //         if(/^1[3456879]\d{9}$/.test(value)) {
    //             return Promise.resolve();
    //         }
    //         return Promise.reject(new Error("请输入正确的手机号"));
    //     }
    //     return Promise.reject(new Error("新手机号不能为空"));
    // }

    return (
        <div id="container" className='websiteTemplate studentDetail'>
            <NewMessage ref={messageRef} done={done} />
            <ConfirmModal ref={confirmRef} done={confirmSave} />
            <Spin size="large" spinning={isLoad} >
                <Form form={form} onFinish={onFinish}>
                    <div className='websiteSysButtonRow'>
                        <div className="detailTitle">
                            Personal Profile
                        </div>
                        <div className="websiteSysButtonBox">
                            <div className='websiteSysButton' onClick={() => update()}><img src={saveImg} />Save</div>
                        </div>
                    </div>
                    <div className="websiteSysContentBox">
                        <div className='websiteSysRow'>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Account User ID</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="accountUserId"
                                    >
                                        <Input type="text" placeholder="Account User ID" disabled />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Student ID</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="studentAcctId"
                                    >
                                        <Input type="text" placeholder="Student ID" disabled />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className='websiteSysRow'>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Student Name</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="studentName"
                                    >
                                        <Input type="text" placeholder="Account User ID" disabled />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Admission Year</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="studentEntryYear"
                                    >
                                        <Input type="text" placeholder="Admission Year" disabled />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className='websiteSysRow'>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Study Year Entry</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="studyYearEntry"
                                    >
                                        <Input type="text" placeholder="Study Year Entry" disabled />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Programme</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="progTitle"
                                    >
                                        <Input type="text" placeholder="Programme" disabled />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className='websiteSysRow'>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Contact Phone</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="contactPhone"
                                        rules={[
                                            { required: false, },
                                        ]}
                                        getValueFromEvent={(e) => e.target.value.replace(/\D/g, '')}
                                    >
                                        <Input type="text" placeholder="Contact Phone" maxLength={12} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam mustFill">Email</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="email"
                                        rules={[
                                            { required: true, message: 'Email is required.' },
                                            { pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, message: 'Incorrect Email format.' },
                                        ]}
                                    >
                                        <Input type="text" placeholder='Email' maxLength={50} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className='websiteSysRow'>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">WhatsApp</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="whatsApp"
                                    >
                                        <Input type="text" placeholder="WhatsApp" maxLength={50} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">WeChat</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="weChat"
                                    >
                                        <Input className="input" type="text" placeholder="WeChat" maxLength={50} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className='websiteSysRow'>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">LinkedIn</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="linkedIn"
                                    >
                                        <Input className="input" type="text" placeholder="LinkedIn" maxLength={50} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Personal Web</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="personalWeb"
                                    >
                                        <Input className="input" type="text" placeholder="Personal Web" maxLength={50} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className='websiteSysRow'>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Profile Picture</div>
                                <div className="websiteSysInput">
                                    <Modal title="" visible={previewVisible} footer={null} onCancel={handleCancel}>
                                        <img alt="example" style={{ width: '100%' }} src={previewImage} />
                                    </Modal>
                                    <Form.Item
                                        name="companyLog"
                                        rules={[
                                            { validator: (rule, value) => checkImg(value) }
                                        ]}
                                    >
                                        <ImgCrop rotationSlider aspect={1 / 1} modalTitle="Edit Picture">
                                            <Upload
                                                action={Config.uploadTestServer}
                                                key={"1"}
                                                accept=".png, .jpg, .jpeg"
                                                listType="picture-card"
                                                fileList={imageFile}
                                                onPreview={handlePreview}
                                                onChange={(file) => handleChangeImg(file)}>
                                                {imageFile.length >= imageNum ? null : <div className='plusOutBox'>
                                                    <PlusOutlined />
                                                    <div>Upload Photo</div>
                                                    <div className='plusOutDesc'>(Recommend uploading 1:1 sized images with a width and height greater than or equal to 100 * 100 pixels)</div>
                                                </div>}
                                            </Upload>
                                        </ImgCrop>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Resume</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="resume"
                                    >
                                        <Upload
                                            maxCount={4}
                                            action={Config.uploadTestServer}
                                            key={"1"}
                                            accept=".pdf,.ppt,.pptx,.doc,.docx,.xls,.xlsx,.jpeg,.jpg,.png,.bmp,.tiff,.mp3,.wav,.txt"
                                            fileList={documentFileList}
                                            beforeUpload={beforeUpload}
                                            onChange={(file) => handleDocumentChange(file)}
                                            showUploadList={false}>
                                            <Button icon={<UploadOutlined />} className='uploadButton'>Select File</Button>
                                        </Upload>
                                        <div className='uploadFileBox'>
                                            {documentFileList.map((item, index) =>
                                                <div className="uploadFileRow" key={index} title={item.name}>
                                                    <img src={tag1} className="tagImg"></img>
                                                    <div onClick={() => downloadFile(item)} className='fileBox'>{item.name}</div>
                                                    <DeleteOutlined className='deleteFileButton' title='Delete File' onClick={() => deleteFile(index)} />
                                                </div>
                                            )}
                                        </div>
                                        <div className='uploadResumeTip'>
                                            At most upload 4 files and each file could not exceed 10MB limit.
                                            <br/>
                                            File type: .pdf, .ptt, .pptx, .doc, .docx, .xls, .xlsx, .jpeg, .jpg, .png, .bmp, .tiff, .mp3, .wav, .txt only.
                                        </div>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="websiteSysButtonBox">
                        <div className='websiteSysButton' onClick={() => update()}><img src={saveImg} />Save</div>
                    </div>
                </Form>
            </Spin>
        </div>
    )

}

export default StudentDetail;